import React from 'react';
import { UserProfile } from '../types';

interface HeaderProps {
  user: UserProfile | null;
  daysRemaining: number;
  onUpgrade: () => void;
  showBack?: boolean;
  onBack?: () => void;
  onProfileClick?: () => void;
}

export const Header: React.FC<HeaderProps> = ({ user, daysRemaining, onUpgrade, showBack, onBack, onProfileClick }) => {
  return (
    <header className="bg-white border-b border-slate-100 px-4 py-3 flex items-center justify-between sticky top-0 z-10 shadow-sm transition-all duration-200">
      <div className="flex items-center gap-2">
        {showBack && onBack && (
          <button 
            onClick={onBack}
            className="p-1 -ml-1 mr-1 rounded-full hover:bg-slate-100 text-slate-600 transition-colors"
            aria-label="Go back"
          >
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2.5} stroke="currentColor" className="w-6 h-6">
              <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
            </svg>
          </button>
        )}
        <img 
             src="https://image2url.com/r2/default/images/1769369928623-3180bbac-a140-4e50-ac88-1cfcf218a72a.png" 
             alt="LoveOnRead Logo" 
             className="w-8 h-8 object-contain"
        />
        <span className="font-bold text-xl tracking-tight">
          <span className="text-love">Love</span>
          <span className="text-read">OnRead</span>
        </span>
      </div>
      
      {user && (
        <div className="flex items-center gap-3">
          {daysRemaining > 0 ? (
             <button 
             onClick={onUpgrade}
             className={`text-xs font-medium px-3 py-1 rounded-full border transition-colors whitespace-nowrap ${
                 user.planType === 'trial' 
                    ? 'bg-amber-100 text-amber-700 border-amber-200 hover:bg-amber-200'
                    : 'bg-green-100 text-green-700 border-green-200 hover:bg-green-200'
             }`}
           >
             {user.planType === 'trial' ? `${daysRemaining} days free` : 'Pro Member'}
           </button>
          ) : (
            <button 
                onClick={onUpgrade}
                className="text-xs font-bold px-3 py-1 bg-red-100 text-red-700 rounded-full border border-red-200 hover:bg-red-200 transition-colors animate-pulse"
            >
                Expired
            </button>
          )}
         
          <button 
            onClick={onProfileClick}
            className="w-10 h-10 rounded-full bg-slate-100 flex items-center justify-center text-slate-600 text-sm font-semibold border border-slate-200 hover:ring-2 hover:ring-brand-200 hover:border-brand-300 transition-all overflow-hidden"
          >
            {user.photoURL ? (
              <img src={user.photoURL} alt={user.name} className="w-full h-full object-cover" />
            ) : (
              user.name.charAt(0).toUpperCase()
            )}
          </button>
        </div>
      )}
    </header>
  );
};